/**
 * Show popup to filter routes
 * @author: adalto.junior
 * Date: 11/12/13
 * Time: 16:36
 */


Greenmile.RouteSuggestion = Greenmile.RouteSuggestion || {};

Greenmile.RouteSuggestion.PopupFilter = (function () {

    function PopupFilter () {

        Monet.GenericModal.apply(this, arguments);

        let __pendingOrder = null;
        let __form;
        let __isOpen;
        let __isStarted;
        let __isDeparted;
        let __hasCapacity;
        let __useExtraItems;
        let __useCancelledItems;
        let __useReturnedItems;
        let __totalTime;
        let __nextStop;
        let __insert;
        let __callbackAfterFilter;

        const createSectionStatusRoute = function () {

            const section = document.createElement('div');
            const titleSection = document.createElement('p');
            const labelKey = 'Greenmile.RouteSuggestion.section.suggestRoute';

            const checkBoxContainer = document.createElement('div'); 
            const titleContainer = document.createElement('div');

            titleSection.innerHTML = Monet.I18n.getResourcesByKey(labelKey);

            const notStarted = new Monet.UI.Fields.Render({
                type: 'CHECKBOX',
                name: 'open',
                label: 'Greenmile.RouteSuggestion.label.routeNotStarted'
            });

            const started = new Monet.UI.Fields.Render({
                type: 'CHECKBOX',
                name: 'started',
                label: 'Greenmile.RouteSuggestion.label.routeStarted'
            });

            const departOrigin = new Monet.UI.Fields.Render({
                type: 'CHECKBOX',
                name: 'departed',
                label: 'Greenmile.RouteSuggestion.label.departOrigin'
            });

            __isOpen = notStarted.render();
            __isOpen.label.setAttribute('for', 'notStarted');
            __isOpen.input.id = 'notStarted';

            __isStarted = started.render();
            __isStarted.label.setAttribute('for', 'isStarted');
            __isStarted.input.id = 'isStarted';

            __isDeparted = departOrigin.render();
            __isDeparted.label.setAttribute('for', 'departOrigin');
            __isDeparted.input.id = 'departOrigin';

            checkBoxContainer.appendChild(__isOpen.rootEl);
            checkBoxContainer.appendChild(__isStarted.rootEl);
            checkBoxContainer.appendChild(__isDeparted.rootEl);

            titleContainer.appendChild(titleSection);

            section.appendChild(titleContainer);
            section.appendChild(checkBoxContainer);

            section.className = 'section';

            return section;

        };

        const createSectionVehicleCapacity = function () {

            const section = document.createElement('div');
            const titleSection = document.createElement('p');
            const labelKey = 'Greenmile.RouteSuggestion.section.vehicleCapacity';

            const checkBoxContainer = document.createElement('div'); 
            const titleContainer = document.createElement('div');

            titleSection.innerHTML = Monet.I18n.getResourcesByKey(labelKey);

            const capacityVehicle = new Monet.UI.Fields.Render({
                type: 'CHECKBOX',
                name: 'hasCapacity',
                label: 'Greenmile.RouteSuggestion.label.hasCapacity'
            });

            __hasCapacity = capacityVehicle.render();
            __hasCapacity.label.setAttribute('for', 'vehicleCapacity');
            __hasCapacity.input.id = 'vehicleCapacity';

            checkBoxContainer.appendChild(__hasCapacity.rootEl);
            titleContainer.appendChild(titleSection);

            section.appendChild(titleContainer);
            section.appendChild(checkBoxContainer);

            section.className = 'section';

            return section;

        };

        const createSectionItemsAvailable = function () {

            const section = document.createElement('div');
            const titleSection = document.createElement('p');
            const labelKey = 'Greenmile.RouteSuggestion.section.deliveryItems';

            const checkBoxContainer = document.createElement('div'); 
            const titleContainer = document.createElement('div');

            titleSection.innerHTML = Monet.I18n.getResourcesByKey(labelKey);

            const extraItems = new Monet.UI.Fields.Render({
                type: 'CHECKBOX',
                name: 'useExtraItems',
                label: 'Greenmile.RouteSuggestion.label.extraItems',
                defaultValue: true
            });

            const canceledItems = new Monet.UI.Fields.Render({
                type: 'CHECKBOX',
                name: 'useCancelledItems',
                label: 'Greenmile.RouteSuggestion.label.canceledItems'
            });

            const returnedItems = new Monet.UI.Fields.Render({
                type: 'CHECKBOX',
                name: 'useReturnedItems',
                label: 'Greenmile.RouteSuggestion.label.returnedItems'
            });

            __useExtraItems = extraItems.render();
            __useExtraItems.label.setAttribute('for', 'extraItems');
            __useExtraItems.input.id = 'extraItems';

            __useCancelledItems = canceledItems.render();
            __useCancelledItems.label.setAttribute('for', 'canceledItems');
            __useCancelledItems.input.id = 'canceledItems';

            __useReturnedItems = returnedItems.render();
            __useReturnedItems.label.setAttribute('for', 'returnedItems');
            __useReturnedItems.input.id = 'returnedItems';

            checkBoxContainer.appendChild(__useExtraItems.rootEl);
            checkBoxContainer.appendChild(__useCancelledItems.rootEl);
            checkBoxContainer.appendChild(__useReturnedItems.rootEl);
            titleContainer.appendChild(titleSection);
            
            section.appendChild(titleContainer);
            section.appendChild(checkBoxContainer);

            section.className = 'section';

            return section;

        };

        const createSectionRouteTime = function () {

            const totalRouteTime = new Monet.UI.Fields.Render({
                type: 'TIME_LENGTH',
                name: 'totalTime',
                label: 'Greenmile.RouteSuggestion.label.totalTime',
                meta: {
                    returnDataAs: 'milliseconds'
                }
            });

            __totalTime = totalRouteTime.render();

            return __totalTime.rootEl;

        };

        const createSectionNextStop = function () {

            const nextStop = new Monet.UI.Fields.Render({
                type: 'TIME_LENGTH',
                name: 'timeToNext',
                label: 'Greenmile.RouteSuggestion.label.timeToNextStop',
                meta: {
                    returnDataAs: 'milliseconds'
                }
            });

            __nextStop = nextStop.render();

            return __nextStop.rootEl;

        };

        const createSectionTimeFields = function () {

            const section = document.createElement('div');

            section.appendChild(createSectionRouteTime());
            section.appendChild(createSectionNextStop());

            section.className = 'section route-times';

            return section;

        };

        const createInsertionMethod = function () {

            const labelKey = 'Greenmile.RouteSuggestion.section.insertionMethod';
            const sectionTitle = document.createElement('p');

            const section = document.createElement('div'); 
            const checkBoxContainer = document.createElement('div'); 
            const titleContainer = document.createElement('div');

            const radios = [{
                type: 'RADIO',
                name: 'insert',
                id: 'bestDistance',
                value: 'BEST_DISTANCE',
                label: 'Greenmile.RouteSuggestion.label.bestDistance'
            }, {
                type: 'RADIO',
                name: 'insert',
                id: 'bestTime',
                value: 'BEST_TIME',
                label: 'Greenmile.RouteSuggestion.label.bestTime'
            }, {
                type: 'RADIO',
                name: 'insert',
                id: 'bestTimeWindow',
                value: 'BEST_TIMEWINDOW',
                label: 'Greenmile.RouteSuggestion.label.bestTimeWindow'
            }, {
                type: 'RADIO',
                name: 'insert',
                id: 'beforeNext',
                value: 'BEFORE_NEXT',
                label: 'Greenmile.RouteSuggestion.label.beforeNextStop'
            }];

            const radioGroup = new Monet.UI.Fields.RadioGroup();

            sectionTitle.innerHTML = Monet.I18n.getResourcesByKey(labelKey);
            titleContainer.appendChild(sectionTitle);

            radioGroup.setRadioButtons(radios);
            radioGroup.render();
            
            section.className = 'section ' + radioGroup.rootEl.className;

            __insert = radioGroup;

            section.appendChild(titleContainer);
            section.appendChild(radioGroup.rootEl);

            return section;

        };

        const triggerLoading = function (context) {

            return function () {
                context.modalForm.toggleLoadingInModalBtn(".sectionButtons");
            };

        }(this);

        const requestFilterRoute = function (filter) {

            triggerLoading();
            try {

                const url = `Route/${__pendingOrder.get('id')}/Suggestion`;
                const request = new Monet.Ajax();

                request.url = url;
                request.data = filter;
                request.method = 'post';

                request.success = function (result) {
                    if (__callbackAfterFilter) {
                        const suggestionCollection = new App.Collections.RouteSuggestion(result);
                        __callbackAfterFilter(suggestionCollection, __pendingOrder);
                    }
                };

                request.error = function (xhr) {
                    Monet.Configurations.errorNotification(null, xhr, null, null);
                    triggerLoading();
                };

                request.send();
            } catch (e) {
                console.log('[ERROR] Error trying retrieve the routes suggested');
                console.log(e);
            }

        };

        const getDataAndFilterRoute = function () {

            return function () {

                const data = {};
                const insertOptionSelected = __insert.getOptionSelected();

                if (!__isOpen.isEmpty()) {
                    data[__isOpen.input.name] = true;
                }

                if (!__isStarted.isEmpty()) {
                    data[__isStarted.input.name] = true;
                }

                if (!__isDeparted.isEmpty()) {
                    data[__isDeparted.input.name] = true;
                }

                if (!__hasCapacity.isEmpty()) {
                    data[__hasCapacity.input.name] = true;
                }

                if (!__useExtraItems.isEmpty()) {
                    data[__useExtraItems.input.name] = true;
                }

                if (!__useCancelledItems.isEmpty()) {
                    data[__useCancelledItems.input.name] = true;
                }

                if (!__useReturnedItems.isEmpty()) {
                    data[__useReturnedItems.input.name] = true;
                }

                if (__totalTime.input.value) {
                    data[__totalTime.input.name] = __totalTime.getValue();
                }

                if (__nextStop.input.value) {
                    data[__nextStop.input.name] = __nextStop.getValue();
                }

                if (insertOptionSelected) {
                    data[insertOptionSelected.input.name] = insertOptionSelected.getValue();
                }

                requestFilterRoute(data);

            };

        }(this);

        const createSectionButtons = function (context) {

            return function () {

                const section = document.createElement('div');
                section.className = 'sectionButtons';

                const buttonFilter = new Monet.UI.Fields.Render({
                    type: 'BUTTON',
                    name: 'filterRouteBySuggestion',
                    label: 'Greenmile.RouteSuggestion.button.filter',
                    customJavaScript: getDataAndFilterRoute
                });

                const buttonCancel = new Monet.UI.Fields.Render({
                    type: 'BUTTON',
                    name: 'closeWindowPopup',
                    label: 'Greenmile.RouteSuggestion.button.cancel',
                    customJavaScript: context.closeModalWindow
                });

                const inputbuttonCancel =  buttonCancel.render().rootEl;
                inputbuttonCancel.setAttribute("name", "closeWindowPopup_exit");

                section.appendChild(buttonFilter.render().rootEl);
                section.appendChild(inputbuttonCancel);

                return section;

            };

        }(this);

        const createTitleSection = function () {
            const section = document.createElement('div');
            section.setAttribute('id', 'routeSuggestionModalTitle');
            
            const title = document.createElement('span');
            const translatedTitle = Monet.I18n.getResourcesByKey('Greenmile.RouteSuggestion.PopupFilter.Title');

            title.innerHTML = `${translatedTitle} ${__pendingOrder.get('id')}`;

            section.appendChild(title);

            return section;
        }


        this.render = function () {

            const divError = document.createElement('div');

            __form = document.createElement('form');
            __form.id = "routeSuggestFilter";

            divError.className += 'monetInlineAlerContainer';

            __form.appendChild(divError);
            __form.appendChild(createSectionStatusRoute());
            __form.appendChild(createSectionVehicleCapacity());
            __form.appendChild(createSectionItemsAvailable());
            __form.appendChild(createSectionTimeFields());
            __form.appendChild(createInsertionMethod());
            __form.appendChild(createSectionButtons());

            return __form;

        };

        this.setPendingOrder = function (pendingOrder) {

            __pendingOrder = pendingOrder;

        };

        this.callbackAfterFilter = function (callback) {
            __callbackAfterFilter = callback;
        };

        this.renderFilterToRouteSuggestion = function () {

            try {

                const popup = document.querySelector(`${this.obj.selector} .popupFormContainer`);

                const titleSection = createTitleSection();
                
                popup.appendChild(titleSection);
                popup.appendChild(this.render());


            } catch (e) {

                const error = new Monet.Exception.ReturnError(this,
                    'Error on render filter to route suggestion', e);
                error.console();

            }

        };

        this.createAllStructure = function (context) {

            return function () {

                context.renderFilterToRouteSuggestion();

            };

        }(this);

    }

    return PopupFilter;

}());
